import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"
import { isMobileMode } from "@/lib/environment"

const MOBILE_TOP_OFFSET = "max(env(safe-area-inset-top, 0px), 64px)"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()
  const mobileMode = isMobileMode()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      offset={mobileMode ? MOBILE_TOP_OFFSET : undefined}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
